import { FEATURES, ROLES } from '~/common/helpers';
import { SideBarRoute, TranslationKeys } from '~/common/types';

const dashboardRoutes: SideBarRoute<keyof TranslationKeys> = {
  label: 'dashboard',
  children: [
    {
      name: 'app.common.sidebar.dashboard',
      icon: 'home',
      to: '/',
      exact: true,
      dataCy: 'dashboard',
    },
    {
      name: 'app.common.sidebar.purchase',
      icon: 'shopping-cart',
      to: '#',
      exact: true,
      dataCy: 'distribution-purchase',
      children: [
        {
          name: 'app.common.sidebar.new_order',
          to: '/purchase',
          dataCy: 'distribution-search-tires',
          exact: true,
          roles: [ROLES.ROLE_LIST_OFFERS],
        },
        {
          name: 'app.common.sidebar.orders',
          to: '/purchase/orders',
          dataCy: 'distribution-orders-list',
          roles: [ROLES.ROLE_LIST_ORDERS],
        },
      ],
    },
    {
      name: 'app.common.sidebar.container_purchase',
      icon: 'shopping-cart',
      to: '#',
      exact: true,
      dataCy: 'container-purchase',
      features: [FEATURES.CONTAINER],
      children: [
        {
          name: 'app.common.sidebar.new_container_order',
          to: '/purchase/containers/orders/search',
          dataCy: 'container-orders-search',
          roles: [ROLES.ROLE_CONTAINER_ORDER_CREATE],
          features: [FEATURES.CONTAINER],
        },
        {
          name: 'app.common.sidebar.container_orders_history',
          to: '/purchase/containers/orders/history',
          dataCy: 'container-orders-history',
          roles: [ROLES.ROLE_CONTAINER_ORDER_LIST],
          features: [FEATURES.CONTAINER],
        },
      ],
    },
    {
      name: 'app.common.sidebar.sale',
      icon: 'money-euro-box',
      to: '#',
      exact: true,
      dataCy: 'sale',
      children: [
        {
          name: 'app.common.sidebar.new_order',
          to: '/call-center',
          dataCy: 'new_call_center_order',
          exact: true,
          roles: [ROLES.ROLE_CREATE_CALL_CENTER_ORDER],
          features: [FEATURES.REDISTRIBUTION],
        },
        {
          name: 'app.common.sidebar.sale.received_orders',
          to: '/purchase/orders/pending',
          dataCy: 'received_orders',
          exact: true,
          roles: [ROLES.ROLE_LIST_PENDING_ORDERS],
          features: [FEATURES.REDISTRIBUTION],
        },
        {
          name: 'app.common.sidebar.sale.processed_orders',
          to: '/purchase/orders/processed',
          dataCy: 'processed_orders',
          exact: true,
          roles: [ROLES.ROLE_LIST_PROCESSED_ORDERS],
          features: [FEATURES.REDISTRIBUTION],
        },
      ],
    },
    {
      name: 'app.common.sidebar.platform.quote',
      icon: 'quote',
      to: '#',
      exact: true,
      dataCy: 'quote',
      children: [
        {
          name: 'app.common.sidebar.quote.create',
          to: '/quotes/search',
          dataCy: 'quote_create',
          exact: true,
          features: [FEATURES.QUOTE],
          roles: [ROLES.ROLE_QUOTE_CREATE],
        },
        {
          name: 'app.common.sidebar.quote.history',
          to: '/quotes/history',
          dataCy: 'quote_history',
          exact: true,
          features: [FEATURES.QUOTE],
          roles: [ROLES.ROLE_QUOTE_LIST],
        },
        {
          name: 'app.common.sidebar.quote.diagnostics',
          to: '/quotes/diagnosis',
          dataCy: 'quote_diagnosis',
          exact: true,
          features: [FEATURES.QUOTE_EXPRESS],
          roles: [ROLES.ROLE_DIAGNOSIS_LIST],
        },
      ],
    },
    {
      name: 'app.common.sidebar.commercial_settings',
      icon: 'settings',
      to: '#',
      exact: true,
      dataCy: 'commercial_settings',
      children: [
        {
          name: 'app.common.sidebar.sale',
          to: '#',
          dataCy: 'settings.sale',
          exact: true,
          children: [
            {
              name: 'app.common.sidebar.commercial_settings.pricing_policy.redistribution',
              to: '/pricing-policies/redistribution',
              dataCy: 'redistribution_pricing_policy',
              exact: true,
              roles: [ROLES.ROLE_REDISTRIBUTION_PRICING_POLICY_LIST],
              features: [FEATURES.REDISTRIBUTION],
            },
            {
              name: 'app.common.sidebar.commercial_settings.pricing_policy.redistribution_service',
              to: '/pricing-policies/redistribution-services',
              dataCy: 'redistribution_service_pricing_policy',
              exact: true,
              roles: [ROLES.ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_LIST],
              features: [FEATURES.REDISTRIBUTION],
            },
            {
              name: 'app.common.sidebar.platform.brands',
              to: '/platform/redistribution/brands',
              dataCy: 'redistribution_brands',
              exact: true,
              features: [FEATURES.REDISTRIBUTION],
              roles: [ROLES.ROLE_REDISTRIBUTION_BRAND_TEMPLATE_LIST],
            },
            {
              name: 'app.common.sidebar.platform.redistribution.suppliers',
              to: '/platform/redistribution/suppliers',
              dataCy: 'redistribution_suppliers',
              exact: true,
              features: [FEATURES.REDISTRIBUTION],
              roles: [ROLES.ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_LIST],
            },
          ],
        },
        {
          name: 'app.common.sidebar.platform.quote',
          to: '#',
          dataCy: 'settings.quote',
          exact: true,
          children: [
            {
              name: 'app.common.sidebar.commercial_settings.pricing_policy.quote',
              to: '/pricing-policies/quotes',
              dataCy: 'quote_pricing_policy',
              exact: true,
              roles: [ROLES.ROLE_QUOTE_PRICING_POLICY_LIST],
              features: [FEATURES.QUOTE],
            },
            {
              name: 'app.common.sidebar.commercial_settings.pricing_policy.quote_service',
              to: '/pricing-policies/services',
              dataCy: 'quote_service_pricing_policy',
              exact: true,
              roles: [ROLES.ROLE_QUOTE_SERVICE_PRICING_POLICY_SETTINGS],
              features: [FEATURES.QUOTE],
            },
            {
              name: 'app.common.sidebar.commercial_settings.default_pricing_policy.list',
              to: '/pricing-policies/quotes/default',
              dataCy: 'quote_default_pricing_policy',
              roles: [ROLES.ROLE_DEFAULT_QUOTE_PRICING_POLICY_LIST],
              exact: true,
              features: [FEATURES.QUOTE],
            },
            {
              name: 'app.common.sidebar.commercial_settings.default_service_pricing_policy.list',
              to: '/pricing-policies/services/default',
              dataCy: 'quote_default_service_pricing_policy',
              roles: [ROLES.ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_LIST],
              exact: true,
              features: [FEATURES.QUOTE],
            },
            {
              name: 'app.common.sidebar.platform.brands',
              to: '/platform/quote/brands',
              dataCy: 'quote_brands',
              exact: true,
              roles: [ROLES.ROLE_QUOTE_BRAND_TEMPLATE_LIST],
              features: [FEATURES.QUOTE],
            },
            {
              name: 'app.common.sidebar.commercial_settings.estimation_display_rules',
              to: '/quotes/settings',
              dataCy: 'estimation_display_rules',
              exact: true,
              roles: [ROLES.ROLE_QUOTE_SETTING_GET],
              features: [FEATURES.QUOTE],
            },
          ],
        },
        {
          name: 'app.common.sidebar.commercial_settings.marketing.advert',
          to: '/platform/distribution/adverts',
          dataCy: 'advert',
          roles: [ROLES.ROLE_ADVERT_LIST],
        },
      ],
    },
    {
      name: 'app.common.sidebar.management',
      to: '#',
      icon: 'globe-cursor',
      dataCy: 'management',
      children: [
        {
          name: 'app.common.sidebar.entities',
          to: '/customers',
          dataCy: 'customers',
          roles: [ROLES.ROLE_CUSTOMER_LIST],
        },
        {
          name: 'app.common.sidebar.users',
          to: '/users',
          dataCy: 'users',
          roles: [ROLES.ROLE_USER_LIST],
        },

        {
          name: 'app.common.sidebar.platform',
          to: '#',
          dataCy: 'platform',
          children: [
            {
              name: 'app.common.sidebar.supplier-templates',
              to: '/platform/distribution/supplier-templates',
              dataCy: 'distribution_suppliers',
              roles: [ROLES.ROLE_SUPPLIER_TEMPLATE_LIST],
            },
            {
              name: 'app.common.sidebar.wheel_supplier_templates',
              to: '/platform/wheels/supplier-templates',
              dataCy: 'wheel_suppliers',
              roles: [ROLES.ROLE_WHEEL_SUPPLIER_TEMPLATE_LIST],
            },
            {
              name: 'app.common.sidebar.platform.brands',
              to: '/platform/distribution/products-brands',
              dataCy: 'distribution_brands',
              roles: [ROLES.ROLE_BRAND_TEMPLATE_LIST],
            },
            {
              name: 'app.common.sidebar.platform.setting_templates',
              to: '/platform/distribution/setting-templates',
              dataCy: 'setting-templates',
              roles: [ROLES.ROLE_SETTING_TEMPLATE_LIST],
            },
            {
              name: 'app.common.sidebar.platform.index',
              to: '/platform/general',
              exact: true,
              dataCy: 'platform_index',
              roles: [ROLES.ROLE_APPLICATION_SETTING_UPDATE],
            },
            {
              name: 'app.common.sidebar.platform.theme',
              to: '/platform/theme',
              exact: true,
              dataCy: 'platform_theme',
              roles: [ROLES.ROLE_APPLICATION_THEME_UPDATE],
            },
            {
              name: 'app.common.sidebar.criteria',
              to: '/platform/criteria',
              dataCy: 'criteria',
              roles: [ROLES.ROLE_CRITERIA_LIST],
            },
            {
              name: 'app.common.sidebar.platform.automaker_groups',
              to: '/platform/automakers',
              dataCy: 'automakers',
              roles: [ROLES.ROLE_AUTOMAKER_LIST],
            },
            {
              name: 'app.common.sidebar.platform.countries',
              to: '/platform/countries',
              dataCy: 'countries',
              roles: [ROLES.ROLE_COUNTRY_LIST],
            },
            {
              name: 'app.common.sidebar.platform.languages',
              to: '/platform/languages',
              dataCy: 'languages',
              roles: [ROLES.ROLE_LANGUAGE_ADMIN],
            },
            {
              name: 'app.common.sidebar.platform.s2s_flow_templates',
              to: '/platform/s2s/s2s-flow-templates',
              dataCy: 's2s_flow_templates',
              roles: [ROLES.ROLE_S2S_FLOW_TEMPLATE_LIST],
            },
          ],
        },
      ],
    },
    {
      name: 'app.common.sidebar.platform.container',
      to: '#',
      dataCy: 'bulk',
      exact: true,
      icon: 'shopping-cart',
      features: [FEATURES.CONTAINER],
      children: [
        {
          name: 'app.common.sidebar.container.history.imports',
          to: '/containers/suppliers/history/imports',
          dataCy: 'bulk_imports',
          features: [FEATURES.CONTAINER],
          exact: true,
          roles: [ROLES.ROLE_CONTAINER_PRICING_POLICY_LIST],
        },
        {
          name: 'app.common.sidebar.container.pricing_policies.assignment',
          to: '/containers/suppliers/assignment',
          dataCy: 'bulk_pricing_policies_assignment',
          features: [FEATURES.CONTAINER],
          roles: [ROLES.ROLE_CONTAINER_PRICING_POLICY_LIST],
          exact: true,
        },
        {
          name: 'app.common.sidebar.container.pricing_policies',
          to: '/containers/suppliers/pricing-policies',
          dataCy: 'bulk_pricing_policies_list',
          features: [FEATURES.CONTAINER],
          roles: [ROLES.ROLE_CONTAINER_PRICING_POLICY_LIST],
          exact: true,
        },
      ],
    },
    {
      name: 'app.common.sidebar.container_orders',
      to: '#',
      dataCy: 'container_orders',
      exact: true,
      icon: 'shopping-cart',
      features: [FEATURES.CONTAINER],
      children: [
        {
          name: 'app.common.sidebar.container_orders.list',
          to: '/containers/suppliers/orders',
          dataCy: 'container_orders_list',
          features: [FEATURES.CONTAINER],
          exact: true,
          roles: [ROLES.ROLE_SUPPLIER_CONTAINER_ORDER_LIST],
        },
      ],
    },
  ],
};
export default [dashboardRoutes];
